import ResqlyGlassNav from '@/components/resqly/ResqlyGlassNav';
import { useAuth } from '@/lib/auth';
import useProviderIncomingOfferPoll from '@/hooks/useProviderIncomingOfferPoll';
import useProviderPushNotifications from '@/hooks/useProviderPushNotifications';

export default function BottomNav({ variant = 'consumer' }) {
  const { token, role } = useAuth();
  const providerActive = variant === 'provider' && Boolean(token) && role === 'provider';
  useProviderPushNotifications(providerActive);
  useProviderIncomingOfferPoll(providerActive);
  return <ResqlyGlassNav variant={variant} />;
}
